module.exports = __webpack_public_path__ + "static/media/Tiktok.4bb4a53.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/client/Tiktok.mp4
// module id = Ukdz
// module chunks = 0